import React, { useState, useEffect } from 'react';

import { Link as RouterLink } from 'react-router-dom';

import {
  makeStyles,
  Typography,
  Card,
  Box,
  Container,
  Link,
  Button
} from '@material-ui/core';

import Page from 'src/shared/ui/components/Page';
import Form from 'src/shared/ui/components/Form';
import processFormErrorMessages from 'src/shared/ui/components/Form/FormErrorMessage';

import validateSchema from 'src/shared/models/SchemaValidator';
import CustomerTerm from 'src/customer-term/models/CustomerTerm';

import getCustomerTermById from 'src/customer-term/use-cases/getCustomerTermById';
import updateCustomerTermById from 'src/customer-term/use-cases/updateCustomerTermById';

import getCustomerTermStatusList from 'src/customer-term-status/use-cases/getCustomerTermStatusList';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  saveButton: {
    top: '-20px'
  },
  backButton: {
    top: '-20px',
    marginRight: theme.spacing(1)
  },
  scrollBox: {
    overflow: 'scroll',
    height: '80vh'
  }
}));

const CustomerTermForm = ({ customerTermId, cancel, success }) => {
  const classes = useStyles();

  const [formFields, setFormFields] = useState([]);

  const initFormFields = async (fields) => {
    const customerTermStatusList = await getCustomerTermStatusList({
      page: null,
      limit: null,
      orderBy: ''
    });

    const instance = CustomerTerm({ fields, customerTermStatusList });

    setFormFields(instance);
  };

  const fetchForm = async () => {
    const record = await getCustomerTermById(customerTermId);

    initFormFields(record);
  };

  useEffect(() => {
    fetchForm();
  }, []);

  const validateFormFields = async (formFieldsValues) => {
    const validatedFormFields = await validateSchema(formFieldsValues);
    formFieldsValues = processFormErrorMessages(
      validatedFormFields,
      formFieldsValues
    );
    setFormFields(formFieldsValues.fields);

    return {
      errors: formFieldsValues.errors,
      fields: validatedFormFields
    };
  };

  const handleChangeFormFieldsValues = (formFieldsValues) => {
    validateFormFields(formFieldsValues);
  };

  const postForm = async () => {
    const validatedForm = await validateFormFields(formFields);
    if (validatedForm.errors) {
      alert('Rellene todos los campos correctamente.');
      return;
    }

    let result = await updateCustomerTermById(
      validatedForm.fields,
      customerTermId
    );
    if (typeof result.id === 'undefined') {
      alert('Se ha producido un error, vuelva a intentarlo');
    } else {
      success();
    }
  };

  return (
    <Page className={classes.root} title="Cliente">
      <Container maxWidth={false}>
        <Box className={classes.navigation} display="flex">
          <Typography color="textSecondary" variant="body2">
            <Link component={RouterLink} to="" onClick={cancel}>
              Cuota
            </Link>
            {` >  ${
              formFields.length && formFields[2].value.length
                ? formFields[2].value
                : ''
            }`}
          </Typography>
        </Box>
        <Box display="flex" justifyContent="flex-end">
          <Button className={classes.backButton} onClick={cancel}>
            {'Volver'}
          </Button>

          <Button
            color="primary"
            variant="contained"
            className={classes.saveButton}
            onClick={postForm}
          >
            Guardar
          </Button>
        </Box>
        <Card>
          <Form
            fields={formFields}
            onChangeFields={handleChangeFormFieldsValues}
          />
        </Card>
      </Container>
    </Page>
  );
};

export default CustomerTermForm;
